import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { removeDeviations } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';
const enhance = compose(connectMediaStore(null, {
    removeDeviations
}), withTranslation());
export class CustomSetDeviationControlButtons extends React.Component {
    render() {
        const { className } = this.props;
        return /*#__PURE__*/ React.createElement(ItemControlButtons, {
            className: className,
            withOneClickDelete: true,
            onDelete: this.onDelete
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "onDelete", ()=>{
            this.props.removeDeviations([
                this.props.deviation
            ]);
        });
    }
}
export default enhance(CustomSetDeviationControlButtons);

//# sourceMappingURL=CustomSetDeviationControlButtons.js.map